import request from "utils/request";
import fetchStream from "fetch-readablestream";

import { baseRequestURL, constructQueryParams } from "api/BaseAPI";

export function getDatasetRatings(datasetId) {
  return request(baseRequestURL + "v1/data/" + datasetId + "/ratings", {
    method: "GET"
  }).then((response) => response);
}

export function getDatasetComments(datasetId) {
  return request(baseRequestURL + "v1/data/" + datasetId + "/comments", {
    method: "GET"
  }).then((response) => response);
}

export function rateDataset(datasetId, rating) {
  return request(baseRequestURL + "v1/data/" + datasetId + "/ratings", {
    method: "POST",
    body: JSON.stringify({
      feedback: rating
    })
  }).then((response) => response);
}

export function postDatasetComment(datasetId, comment) {
  return request(baseRequestURL + "v1/data/" + datasetId + "/comments", {
    method: "POST",
    body: JSON.stringify({
      message: comment
    })
  }).then((response) => response);
}

export function deleteComment(commentId) {
  return request(baseRequestURL + "v1/comments/" + commentId, {
    method: "DELETE"
  }).then((response) => response);
}
